module.exports = __webpack_public_path__ + "img/sbanner_02.f71d05bf.jpg";